import React, { FC } from 'react';

interface FieldCheckboxProps {
    input: {
        name: string;
        value: string | number;
        onChange: ( event: React.ChangeEvent<HTMLInputElement> ) => void;
        onBlur: ( event: React.FocusEvent<HTMLInputElement> ) => void;
        onFocus: ( event: React.FocusEvent<HTMLInputElement> ) => void;
    };
    label: string;
    type: string;
    meta: {
        touched: boolean;
        error?: string;
    };
}

const FieldCheckbox: FC<FieldCheckboxProps> = ( { input, label, type, meta: { touched, error } } ) => (
    <div className="checkbox">
        <label>
            <input { ...input } type={ type } />
            { label }
        </label>
        { touched && error && <span className="help-block">{ error }</span> }
    </div>
);

export default FieldCheckbox;
